import { render, staticRenderFns } from "./KgjtWebsiteLearnVideo.vue?vue&type=template&id=fc086d7c&scoped=true&"
import script from "./KgjtWebsiteLearnVideo.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteLearnVideo.vue?vue&type=script&lang=js&"
import style0 from "./KgjtWebsiteLearnVideo.vue?vue&type=style&index=0&id=fc086d7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc086d7c",
  null
  
)

export default component.exports